import {
  getActiveMultiApprovalRules,
  getApprovalRules,
  getChildApprovalRules,
  getIsParentApprovalActiveRules,
  setApprovalRules,
  setChildApprovalRules,
} from 'src/clients';
import { RootState } from 'src/redux/reducers/rootReducer';
import {
  SubmitChiltMultiApprovalData,
  SubmitMultiApprovalData,
} from '../types';
import { ACTION_TYPES } from './types';

export const fetchMultiApproval = () => {
  return {
    types: [
      ACTION_TYPES.MULTI_APPROVAL_FETCH,
      ACTION_TYPES.MULTI_APPROVAL_FETCH_SUCCESS,
      ACTION_TYPES.MULTI_APPROVAL_FETCH_FAILED,
    ],
    client: () => getApprovalRules(),
  };
};

export const fetchChildMultiApproval = () => {
  return {
    types: [
      ACTION_TYPES.CHILD_MULTI_APPROVAL_FETCH,
      ACTION_TYPES.CHILD_MULTI_APPROVAL_FETCH_SUCCESS,
      ACTION_TYPES.CHILD_MULTI_APPROVAL_FETCH_FAILED,
    ],
    client: () => getChildApprovalRules(),
  };
};

export const submitMultiApproval = (data: SubmitMultiApprovalData[]) => {
  return {
    types: [
      ACTION_TYPES.MULTI_APPROVAL_SUBMIT,
      ACTION_TYPES.MULTI_APPROVAL_SUBMIT_SUCCESS,
      ACTION_TYPES.MULTI_APPROVAL_SUBMIT_FAILED,
    ],
    client: () => setApprovalRules(data),
  };
};

export const submitChildMultiApproval = (
  data: SubmitChiltMultiApprovalData,
) => {
  return {
    types: [
      ACTION_TYPES.CHILD_MULTI_APPROVAL_SUBMIT,
      ACTION_TYPES.CHILD_MULTI_APPROVAL_SUBMIT_SUCCESS,
      ACTION_TYPES.CHILD_MULTI_APPROVAL_SUBMIT_FAILED,
    ],
    client: () => setChildApprovalRules(data),
  };
};

export const fetchActiveMultiApproval = () => {
  return {
    types: [
      ACTION_TYPES.ACTIVE_MULTI_APPROVAL_FETCH,
      ACTION_TYPES.ACTIVE_MULTI_APPROVAL_FETCH_SUCCESS,
      ACTION_TYPES.ACTIVE_MULTI_APPROVAL_FETCH_FAILED,
    ],
    client: () => getActiveMultiApprovalRules(),
  };
};

export const fetchIsParentApprovalActiveRules = () => {
  return {
    types: [
      ACTION_TYPES.CHILD_MULTI_APPROVAL_ACTIVE_FETCH,
      ACTION_TYPES.CHILD_MULTI_APPROVAL_ACTIVE_FETCH_SUCCESS,
      ACTION_TYPES.CHILD_MULTI_APPROVAL_ACTIVE_FETCH_FAILED,
    ],
    client: () => getIsParentApprovalActiveRules(),
    shouldCallAPI: (state: RootState) =>
      state.multiApproval.parentActive.data == null &&
      !state.multiApproval.parentActive.loading,
  };
};
